import * as React from "react";
const SvgImages = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "rgb(234, 67, 53)", xmlns: "http://www.w3.org/2000/svg", className: "k2eJge", style: {
  width: 16,
  height: 16
}, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 14.222V1.778C16 .796 15.204 0 14.222 0H1.778C.796 0 0 .796 0 1.778v12.444C0 15.204.796 16 1.778 16h12.444c.982 0 1.778-.796 1.778-1.778zM4.889 9.333l2.222 2.671L10.222 8l4 5.333H1.778l3.11-4z" }));
export default SvgImages;
